export default {
  metaTitle: '商品快捷编辑',
  listingId: 'Listing编号',
  title: '商品名称',
  skuCount: 'SKUs',
  editListing: '编辑部分信息',
  fullEditFun: '编辑全部信息',
  showCountry: '国家站',
  baseStation: '基站',
  expand: '扩展',
  finalFreight: '尾程运费配置',
  priceUse: '批量改价',
  nation: '应用国家站',
  listPriceSection: '当前市场参考价区间',
  salePriceSection: '当前售价区间',
  newPrice: '请输入要应用的新价格',
  notFill: '不调整的价格请勿填写',
  cancel: '取消操作',
  determine: '确定应用',
  listingTitle: '商品名称',
  chooseCategory: '已选品类',
  brand: '品牌',
  shortDescr: '简述',
  warehouse: '仓库',
  onlinePay: '在线支付 ',
  category: '品类',
  COD: '货到付款',
  paymentMethod: '支付方式',
  excludePaymentMethod: '已被拒绝支付选项',
  online: '在线支付',
  manufactureId: '供应商商品ID',
  listPrice: '市场参考价',
  salePrice: '售价',
  quantity: '数量',
  availableStock: '可用库存',
  photos: 'SKU缩略图',
  titleRules: '内容不能为空',
  warehouseRules: '请选择仓库',
  integerRules: '请输入数值',
  SKU_ID: 'SKU编号',
  manufacture_ID: '供应商商品ID',
  mainSpec: '规格',
  operation: '操作',
  setOnline: '上架',
  setOffline: '下架',
  priceNot_0: '价格设置不能为0！',
  priceCannotHigher: '售价不应大于市场参考价',
  JPG_GIF_PNG: '请上传JPG/GIF/PNG类型的图片',
  file_2M: '文件过大，单个文件上限为2M',
  image_5: '最多可以上传5张图片',
  saveEdit: '请保存或关闭sku修改界面',
  successEdit: '价格修改成功',
  inputError: '输入不正确',
  newPriceUse: '请输入要应用的新价格',
  priceUnder: '市场参考价和售价低于原最低值的70%，您确定要修改吗?',
  priceExceed: '市场参考价和售价高于原最高值的50%，您确定要修改吗?',
  listPriceUnder: '市场参考价低于原最低值的70%，您确定要修改吗?',
  listPriceExceed: '市场参考价高于原最高值的50%，您确定要修改吗?',
  salePriceUnder: '售价低于原最低值的70%，您确定要修改吗?',
  salePriceExceed: '售价高于原最高值的50%，您确定要修改吗?',
  unable: '售价不能高于市场参考价',
  maxListPrice: '市场参考价不能小于原有售价的最大值',
  minListPrice: '售价不能大于原有的市场参考价的最小值',

  prePaymentSite: '预付款设置',
  prePaymentSiteProduct: '商品预付款设置',
  preRatio: '预付比例',
  preRatioItem1: '按平台统一设置',
  preRatioItem2: '不允许预付款',
  preRatioItem3: '为此商品单独设置',
  preRatioLimit: '1-80之间整数',
  merge: '合并提交',
  allow: '允许',
  notAllow: '不允许',
  preTips1: '选择允许时，商品可加入购物车，与其他允许合并提交的商品一起从购物车提交订单',
  preTips2: '选择不允许时，商品不可加入购物车，只能直接购买',
  save: '保存',
  ratioCheck: '预付比例应是1至80之间的整数',

  product: '此商品已违规下架，并且锁定不能编辑',
  violations: '该商品已进行违规处理',
  productViolations: '此商品已做违规处理并锁定不能编辑',
  notFbkProduct: '尚未备货仓建档',
  physicalWarehouse: '物理仓库存:{0}, 可用:{1}, 详情',
  nonFbkInventory: '非FBK库存: {0} (可用.',
  fbkInventory: 'FBK库存:  {0} (可用. {1})',
  nonFbk: '非FBK库存',
  pleaseAvailInventory: '请填写库存'
}
